import { Quill } from "react-quill";

const Block = Quill.import('blots/block');
const Inline = Quill.import('blots/inline');
const AlignStyle = Quill.import('attributors/style/align');

class DivBlock extends Block {
    static create(value: any) {
        const node = super.create(value);
        node.style.margin = '0';
        node.style.padding = '0';
        return node;
    }
}

DivBlock.tagName = 'DIV';
DivBlock.blotName = 'block';

class UnderlineBlot extends Inline {
    static create() {
        const node = super.create();
        node.style.textDecoration = 'underline';
        return node;
    }

    static formats(domNode: HTMLElement) {
        return domNode.style.textDecoration === 'underline';
    }
}

UnderlineBlot.blotName = 'underline';
UnderlineBlot.tagName = 'span';


Quill.register(AlignStyle, true);
Quill.register(UnderlineBlot, true);

Quill.register(DivBlock, true);